@use "../../styles/breakpoint.module.scss" as *;

@mixin svg-style {
    width: 1em;
    height: 1em;
}

@mixin common-clickable {
    & {
        transition:
            background-color 0.3s ease-in-out,
            color 0.3s ease-in-out,
            border-radius 0.3s ease-in-out;
        letter-spacing: 0.04em;
    }

    &:disabled,
    &.disabled {
        opacity: 0.5;
        cursor: default;
    }

    & svg {
        @include svg-style;
    }
}

// things that we want on all clickables, including "unstyled" ones
.base {
    composes: outline from "../../styles/composable/utility.module.css";
}

.clickable {
    @include common-clickable;
}

@mixin filled-button {
    @include common-clickable;

    color: var(--filled-button-text);
    background-color: var(--color-contrast);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    padding: var(--spacer-16) var(--spacer-32);
    gap: var(--spacer-8);
    overflow: hidden;
    border-radius: var(--border-radius-md);
    text-transform: uppercase;
    font: var(--font-button-16);

    &:hover:not(:disabled, .disabled),
    &.hover:not(:disabled, .disabled) {
        background-color: var(--midnight);
        color: var(--white);
        border-radius: var(--border-radius-lg);
    }
}

.primaryButton {
    @include filled-button;
}

@mixin borderless-button {
    @include common-clickable;

    gap: var(--spacer-8);
    display: inline-flex;
    font: var(--font-button-16);
    color: var(--color-contrast);
    text-transform: uppercase;
    position: relative;

    &:not(:has(> svg))::after {
        content: "";
        position: absolute;
        left: 0;
        top: 100%;
        width: 100%;
        border-top: 2px solid currentColor;
        transition: width 0.3s ease-in-out;
    }

    & svg {
        @include svg-style;
    }

    &:hover:not(:disabled, .disabled),
    &.hover:not(:disabled, .disabled) {
        color: var(--color-hover);

        &::after {
            width: 0;
        }
    }
}

.buttonSecondary {
    @include borderless-button;
}

// Pulled from thelab-ui to reset links in a richtext context
:global(:where(.linkReset)) {
    cursor: pointer;
    display: inline-block;
    color: inherit;
    font-size: inherit;
    line-height: inherit;
    text-decoration: none;
}

.iconButton {
    @include common-clickable;

    color: var(--color-primary);
    background-color: var(--color-contrast);
    border-radius: var(--border-radius-full);
    padding: var(--spacer-16);
    line-height: 0;

    & svg {
        @include svg-style;
    }

    &:hover:not(:disabled, .disabled),
    &.hover:not(:disabled, .disabled) {
        background-color: var(--midnight);
        color: var(--white);
    }

    &.transparent {
        border-radius: var(--border-radius-md);
        color: var(--white);
        background: var(--dark-overlay-20);

        &:hover:not(:disabled, .disabled),
        &.hover:not(:disabled, .disabled) {
            background: var(--dark-overlay-40);
        }
    }
}

.storyGrid {
    display: grid;
    grid-template-columns: repeat(var(--column-count, 4), 1fr);
    background: var(--mid-grey);

    & > * {
        grid-column: span 1;
        padding: 0.5em;
        background: transparent !important;
        display: flex;
        align-items: center;
    }
}
